import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class SmartInsightsPropertyTagsSubscriptionModel extends Model {
  [Type] = 'smart-insights/property-tags/subscription' as const;

  @attr('string') declare name: string;
}
